import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { ApplicationContext } from '@/v2/state/providers';
import TimeLine from '@/v2/components/layouts/TimeLine';
import Text from '@/v2/components/atoms/Text';
import Button from '@/v2/components/atoms/Button';
import VLPPlus from '@/v2/components/atoms/Button/VLPPlus';
import { AnalyticsContext } from '@/v2/components/application/Analytics';

import './RegisterInterest.scss';

const propTypes = {
    ctaCallback: PropTypes.func,
    closeOverlay: PropTypes.func,
};

const defaultProps = {
    ctaCallback: null,
    closeOverlay: null,
};

const RegisterInterest = ({ ctaCallback, closeOverlay }) => {
    const [data] = useContext(ApplicationContext);
    const { register } = data;
    const { trackEvent } = useContext(AnalyticsContext);
    const [animateButton, setButtonAnimate] = useState(false);

    const vlpPlusTrackEvent = () => {
        const trackingObject = {
            destination: register.text.nextStepCta.vlpPlus.href,
            locationInPage: 'registerInterest',
            buttonText: register.text.nextStepCta.vlpPlus.text.toLowerCase(),
        };

        trackEvent('genericClick', trackingObject);
    };

    const onRegisterClick = () => {
        trackEvent('genericClick', {
            destination: register.text.nextStepCta.register.href,
            locationInPage: 'registerInterest',
            buttonText: register.text.nextStepCta.register.text.toLowerCase(),
        });
        closeOverlay();
        setButtonAnimate('out');
        const timer = setTimeout(() => {
            ctaCallback();
        }, 2000);

        return () => clearTimeout(timer);
    };

    const onVlpClick = () => {
        closeOverlay();
        trackEvent('genericClick', {
            destination: register.text.nextStepCta.vlpPlus.href,
            locationInPage: 'registerInterest:vlpClick',
            buttonText: register.text.nextStepCta.vlpPlus.text.toLowerCase(),
        });
        setButtonAnimate('out');
        const timer = setTimeout(() => {
            ctaCallback();
        }, 2000);

        return () => clearTimeout(timer);
    };

    return (
        <div className="RegisterInterest">
            <div className="RegisterInterest__content">
                <Text className="h2 RegisterInterest__heading" component="h1">
                    {register.text.title}
                </Text>
                <Text className="RegisterInterest__copy" component="p">
                    {register.text.body}
                </Text>
                <div className="RegisterInterest__ctas">
                    <Button
                        href={register.text.nextStepCta.register.href}
                        animate={animateButton ? 'out' : null}
                        variant="primary-gold-light"
                        onClick={onRegisterClick}
                    >
                        {register.text.nextStepCta.register.text}
                    </Button>
                    <VLPPlus
                        href={register.text.nextStepCta.vlpPlus.href}
                        animate={animateButton ? 'out' : null}
                        onVlpClick={onVlpClick}
                        onTrackEvent={vlpPlusTrackEvent}
                    >
                        {register.text.nextStepCta.vlpPlus.text}
                    </VLPPlus>
                </div>
            </div>
            <TimeLine />
        </div>
    );
};

RegisterInterest.propTypes = propTypes;
RegisterInterest.defaultProps = defaultProps;

export default RegisterInterest;
